import React from 'react';
import { FadeIn } from './FadeIn';
export const NewOpportunity = () => {
  return <section className="py-24 bg-beige/30" data-id="element-121">
      <div className="max-w-6xl mx-auto px-6" data-id="element-122">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-123">
          <FadeIn data-id="element-124">
            <h2 className="text-4xl md:text-5xl mb-6" data-id="element-125">
              El problema NO es que no seas capaz de emprender.
            </h2>
            <p className="text-xl md:text-2xl text-text-brown/80 font-serif italic" data-id="element-126">
              "El problema es que te mostraron negocios demasiado complicados."
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-127">
          {[{
          img: 'https://images.unsplash.com/photo-1602874801007-bd458cb6c975?auto=format&fit=crop&q=80',
          title: 'Velas Aesthetic'
        }, {
          img: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&q=80',
          title: 'Desde Casa'
        }, {
          img: 'https://images.unsplash.com/photo-1605265123961-750d9990e15c?auto=format&fit=crop&q=80',
          title: 'Baja Inversión'
        }, {
          img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&q=80',
          title: 'Ventas por IG'
        }].map((item, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-128">
              <div className="group relative rounded-2xl overflow-hidden aspect-[4/5] shadow-soft" data-id="element-129">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-130" />
                <div className="absolute inset-0 bg-gradient-to-t from-text-dark/80 via-text-dark/20 to-transparent flex items-end p-4 md:p-6" data-id="element-131">
                  <h3 className="text-white font-serif text-lg md:text-xl" data-id="element-132">
                    {item.title}
                  </h3>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};